export class ConfirmedService {
  public id: number;
  public confirmed: boolean;

  public constructor() {
    this.id = 0;
    this.confirmed = false;
  }
}
